define('AwaLabs.Inspectlet.Configuration', [
], function AwaLabsInspectletConfiguration(
) {
    'use strict';

    return {
        configuration: null,
        initialize: function initialize(container) {
            /** @type EnvironmentComponent */
            var environment = container.getComponent('Environment');
            this.configuration = environment.getConfig('inspectlet') || {};
        },
        get: function getConfig(key, defaultValue) {
            if (!this.configuration) {
                console.error('Inspectlet.Configuration not initialized.');
                return defaultValue;
            }
            if (key in this.configuration) {
                return this.configuration[key];
            }
            return defaultValue;
        },

        isEnabled: function isEnabled() {
            return !!this.get('enabled', true);
        },
        isAllowedDomain: function isAllowedDomain() {
            var allowedDomain = this.get('allowedDomain', 'applejack.com');
            return !!(window.location && window.location.hostname && window.location.hostname === allowedDomain);
        },
        getWebsiteId: function getWebsiteId() {
            return parseInt(this.get('websiteId', '1578310406'), 10);
        },
        isAbLoaderEnabled: function isAbLoaderEnabled() {
            return this.get('abLoaderEnabled', false);
        }
    };
});

